import React, {useEffect, useCallback} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {logPageLoadEvents} from '@ibibo/analytics';
import {Helmet} from 'react-helmet';
import * as S from './myTrips.styles';

import Loader from '../../../stories/components/Loader/Loader';

import {
  MY_TRIPS_DETAILS,
  HOTELS_HOME,

  updateActiveTab,

  myTripsLoaderSelector,
  myTripsHeadersSelector,
  myTripsActiveTabSelector,
  myTripsBookingDataSelector,

  fetchMyTripsData,
} from '@ibibo/myaccount-reducer';

import MyTripsHeader from '../../../stories/components/myTripsListing/ListingHeader/ListingHeader';
import ListingBody from '../../../stories/components/myTripsListing/ListingBody/ListingBody';

const MyTrips = () => {

  const dispatch = useDispatch();

  const myTripsHeaders = useSelector(myTripsHeadersSelector);
  const activeTab = useSelector(myTripsActiveTabSelector);
  const loading = useSelector(myTripsLoaderSelector);
  const bookingDetails = useSelector(myTripsBookingDataSelector);

  const fetchMyTripsDataCaller = useCallback(() => {
    return dispatch(fetchMyTripsData());
  }, [dispatch]);

  useEffect(() => {
    fetchMyTripsDataCaller();
  }, []);

  useEffect(() => {
    logPageLoadEvents('mybookings:listing', {});
  }, []);

  const updateActiveTabFnc = (tabKey) => {
    dispatch(updateActiveTab(tabKey));
  }

  const navigateToMyTripsDetails = (id) => {
    window.open(`${MY_TRIPS_DETAILS}${id}/?search_id=${id}`, '_blank');
  }
  
  const navigateToHotels = () => {
    window.open(`${HOTELS_HOME}`, '_self');
  }

  return(
    <>
      <Helmet
        title={'myPartner by MakeMyTrip'}
        meta={[{name: 'robots', content: 'noindex, nofollow'}]}
      />
    <S.MyTripsMainOuterWrap>
      <MyTripsHeader headers={myTripsHeaders} activeTab={activeTab} updateActiveTab={updateActiveTabFnc} />
      {loading && <Loader props={{margin: '-4rem 0 4rem 0'}}/>}
      {(!loading && <ListingBody bookingDetails={bookingDetails} activeTab={activeTab} navigateToMyTripsDetails={navigateToMyTripsDetails} navigateToHotels={navigateToHotels} />) || null}
    </S.MyTripsMainOuterWrap>
    </>
  );
}

export default MyTrips;